import React, { useEffect, useRef, useState } from "react";
import PreAuthStepper from "../../components/patient/PreAuthStepper";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store/store";
import {
  prevStep,
  nextStep,
  setWizards,
  resetPortalData,
  setCurrentStep,
  fetchPreAuthStepper,
  nextStep2,
  fetchStepperData,
  getPortalStatusList,
} from "../../models/preAuthSlice";
import { PREAUTH_MICROSERVICE } from "../../utils/constants";
import {
  wizardSteps,
  wizardStepsCghsIp,
  wizardStepsCghsOp,
  wizardStepsStarHealth,
  wizardStepsEchs,
  wizardStepsEchsOp,
} from "../../props/PreAuthProps";
import { useLocation, useParams } from "react-router-dom";
import {
  clearFetchBasicDetail,
  getBasicDetails,
  getBasicDetails2,
  getPatientById,
  getPatientSchemes,
  getSchemeMetaData,
} from "../../models/patientSlice";
import { getPatientBasicDetails } from "../../apis/patientService";
import FloatingDrawer from "../../utils/documentDrawer";
import { resetPreAuthClaimRes } from "../../models/preAuthClaimSlice";

interface OptionType {
  id: number;
  state: string;
}

const PreAuthContainer = () => {
  const dispatch = useDispatch<AppDispatch>();

  const [urlLink, setUrlLink] = useState<string>("");
  const { patients, hospital, preAuth, auth, discharge } = useSelector(
    (state: RootState) => state
  );

  const [claimId, setClaimId] = useState<string | null>(null);
  const [regId, setRegId] = useState<string | null>(null);
  const [dischargeId, setDischargeId] = useState<number | null>(null);
  const [callVisit, setCallVisit] = useState<boolean>(false); // to call visit api when in preauth status get changed on clicked button status
  const [initiateToPreAuth, setInitiateToPreAuth] = useState<boolean>(true); //to initiate pre auth
  const [isEditing, setIsEditing] = useState<boolean>(false);
  const [selectedStatusValue, setSelectedStatusValue] =
    useState<OptionType | null>(null);
  const [currentStatus, setCurrentStatus] = useState<string | null>(null);
  const [statusOptions, setStatusOptions] = useState<Array<OptionType> | null>([
    { id: 8, state: "Draft" },
    { id: 9, state: "Pending Review" },
    { id: 10, state: "Pending More Info" },
    { id: 2, state: "Initiated" },
    { id: 3, state: "Denied" },
    { id: 4, state: "Completed" },
    { id: 11, state: "Query" },
    { id: 7, state: "Error" },
  ]);

  const location = useLocation();
  const path = location.pathname;
  const visitId = path.split("/")[3];

  const isFirstRender = useRef(true);

  useEffect(() => {
    dispatch(clearFetchBasicDetail(""));
    dispatch(resetPreAuthClaimRes());
  }, [visitId]);

  useEffect(() => {
    if (patients?.fetchBasicDetails2?.casesResponse?.schemeMetaDataId) {
      const schemeId = patients?.fetchBasicDetails2?.casesResponse?.schemeMetaDataId
      // dispatch(
      //   getPortalStatusList({ schemeId: schemeId })
      // );
      dispatch(
        getSchemeMetaData(schemeId)
      );
    }
  }, [patients?.fetchBasicDetails2?.casesResponse?.patientSchemeId]);

  useEffect(() => {
    if (visitId) {
      dispatch(resetPortalData());
      dispatch(
        getBasicDetails2({
          id: parseInt(visitId),
        })
      );
      dispatch(
        getBasicDetails({
          id: parseInt(visitId),
        })
      );
    }
  }, [visitId, isFirstRender]);

  useEffect(() => {
    return () => {
      dispatch(clearFetchBasicDetail(""));
      dispatch(resetPreAuthClaimRes());
    };
  }, []);

  const next = () => {
    // dispatch(nextStep());
    dispatch(nextStep2());
  };
  const prev = () => {
    dispatch(prevStep());
  };
  const handleInitiatePreAuth = () => {
    setInitiateToPreAuth(true);
    next();
  };

  const handleEditClick = (): void => {
    setIsEditing(true);
    const selectedOption =
      statusOptions &&
      statusOptions?.find((option) => option.state === currentStatus);
    setSelectedStatusValue(selectedOption ?? null);
  };

  const handleCancelClick = (): void => {
    setIsEditing(false);
    setSelectedStatusValue(null);
  };

  const handleSaveClick = (): void => {
    if (selectedStatusValue) {
      setCurrentStatus(selectedStatusValue?.state);
    }
    setIsEditing(false);
  };

  const handleChange = (value: number): void => {
    const selectedOption =
      statusOptions && statusOptions?.find((option) => option.id === value);
    setSelectedStatusValue(selectedOption || null);
  };

  const handleCurrentStep = (updatedStep: any) => {
    if (updatedStep?.completed || true) {
      dispatch(setCurrentStep(updatedStep?.step));
    }
  };

  // useEffect(() => {
  // if (
  //   patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
  //   "CGHS" ||
  //   patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
  //   "CAPF"
  // ) {
  //   if (
  //     patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
  //     "OP"
  //   ) {
  //     dispatch(setWizards(wizardStepsCghsOp));
  //   } else if (
  //     patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
  //     "IP" ||
  //     patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
  //     "EMERGENCY"
  //   ) {
  //     dispatch(setWizards(wizardStepsCghsIp));
  //   }
  // } else if (
  //   patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
  //   "STAR HEALTH"
  // ) {
  //   dispatch(setWizards(wizardStepsStarHealth));
  // } else if (
  //   patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
  //   "ECHS"
  // ) {
  //   if (
  //     patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
  //     "OP"
  //   ) {
  //     dispatch(setWizards(wizardStepsEchsOp));
  //   } else if (
  //     patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
  //     "IP" ||
  //     patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
  //     "EMERGENCY"
  //   ) {
  //     dispatch(setWizards(wizardStepsEchs));
  //   }
  // } else {
  //   dispatch(setWizards(wizardSteps));
  // }

  // if (patients?.fetchBasicDetails?.visitInfoResponse) {
  //   const currentStatus = patients?.fetchBasicDetails?.visitInfoResponse?.message || "PENDING"
  //   const updatedStep = getNextStep(currentStatus);
  //   dispatch(setCurrentStep(updatedStep?.steps))
  // }
  // }, [
  //   dispatch,
  //   patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName,
  //   patients?.fetchBasicDetails?.visitInfoResponse?.visitType,
  // ]);

  // useEffect(()=>{
  //   if (patients?.fetchBasicDetails?.visitInfoResponse) {
  //     const currentStatus = patients?.fetchBasicDetails?.visitInfoResponse?.message || "PENDING"
  //     const updatedStep = getNextStep(currentStatus);
  //     dispatch(setCurrentStep(1))
  //   }
  // }, [patients?.fetchBasicDetails?.visitInfoResponse])

  const staticStatus = [
    "Registration Pending",
    "Registration Initiated",
    "Registration Completed",
    "Data saved on Portal",
  ];

  const getStageFromStatus = (status: string): string | null => {
    const keywords = preAuth?.allWizardSteps.map((step) =>
      step.title.toUpperCase().replace(/[- ]/g, "")
    );
    for (let keyword of keywords) {
      if (status.toUpperCase().includes(keyword)) {
        const matchedStep = preAuth?.allWizardSteps.find(
          (step) => step.title.toUpperCase().replace(/[- ]/g, "") === keyword
        );
        return matchedStep ? matchedStep.title : null;
      }
    }
    return null;
  };

  // const getNextStep = (completedStatus: string) => {
  //   let status = completedStatus;
  //   if (staticStatus.includes(completedStatus)) status = "CasePreAuth";
  //   const completedStepTitle = getStageFromStatus(status);

  //   if (!completedStepTitle) {
  //     return preAuth?.allWizardSteps[0];
  //   }

  //   const completedStep = preAuth?.allWizardSteps.find(step => step.title === completedStepTitle);

  //   if (!completedStep) {
  //     return preAuth?.allWizardSteps[0];
  //   }

  //   const nextStepIndex = status.toUpperCase().includes("COMPLETED") ? completedStep.steps + 1 : completedStep.steps;
  //   if (nextStepIndex >= preAuth?.allWizardSteps.length) {
  //     return preAuth?.allWizardSteps[0];
  //   }
  //   return preAuth?.allWizardSteps[nextStepIndex];
  // }

  // const getNextStepForWizard = (completedStatus: string) => {
  //   let status = completedStatus;
  //   if (staticStatus.includes(completedStatus)) status = "CasePreAuth";
  //   const completedStepTitle = getStageFromStatus(status);

  //   if (!completedStepTitle) {
  //     return preAuth?.allWizardSteps[0];
  //   }

  //   const completedStep = preAuth?.allWizardSteps.find(step => step.title === completedStepTitle);

  //   if (!completedStep) {
  //     return preAuth?.allWizardSteps[0];
  //   }

  //   const nextStepIndex = status.toUpperCase().includes("COMPLETED") ? completedStep.steps + 1 : completedStep.steps;
  //   if (nextStepIndex >= preAuth?.allWizardSteps.length) {
  //     return preAuth?.allWizardSteps?.[preAuth?.allWizardSteps.length-1];
  //   }
  //   return preAuth?.allWizardSteps[nextStepIndex];
  // }

  // useEffect(() => {
  //   const interval = setInterval(() => {

  //     const ClaimId = localStorage.getItem("claimId");
  //     if(ClaimId){
  //       const storedClaimId = JSON.parse(ClaimId);
  //       if (storedClaimId) {
  //
  //         setClaimId(storedClaimId);
  //         localStorage.removeItem("claimId");
  //       }
  //     }
  //   }, 2000);

  //   return () => clearInterval(interval);
  // }, []);

  const portalName =
    patients?.fetchBasicDetails2?.casesResponse?.schemeMetaDataName ===
      "MEDI ASSIST" ||
    patients?.fetchBasicDetails2?.casesResponse?.schemeMetaDataName
      ?.toLowerCase()
      ?.includes("aditya birla")
      ? "IHX"
      : patients?.fetchBasicDetails2?.casesResponse?.schemeMetaDataName;

  useEffect(() => {
    if (
      initiateToPreAuth &&
      patients?.fetchBasicDetails2?.casesResponse?.patientSchemeId &&
      patients?.fetchBasicDetails2?.casesResponse?.patientId &&
      patients?.fetchBasicDetails2?.casesResponse?.id
    ) {
      const hospitalId = patients?.fetchBasicDetails2?.casesResponse?.healthCareId;
      const patientId = patients?.fetchBasicDetails2?.casesResponse?.patientId;
      const caseId = patients?.fetchBasicDetails2?.casesResponse?.id;
      const casePreAuthId = "3";
      const schemeId =
        patients?.fetchBasicDetails2?.casesResponse?.patientSchemeId;
      const schemeName =
        patients?.fetchBasicDetails2?.casesResponse?.schemeMetaDataName;
      const templateCategory = "preAuth";
      const templateSubCategory = portalName;
      const visitId = patients?.fetchBasicDetails2?.visitInfoResponse?.id;
      const isUpdate = "false";
      const token = auth?.accessToken;
      const data = false;

      // Validate mandatory fields for post
      const areFieldsValidPost = [
        hospitalId,
        patientId,
        caseId,
        schemeId,
        schemeName,
        templateSubCategory,
        visitId,
        token,
        isUpdate,
      ].every((field) => field);

      // Validate mandatory fields for patch
      const areFieldsValidPatch = [
        // hospitalId,
        patientId,
        caseId,
        schemeId,
        schemeName,
        templateSubCategory,
        visitId,
        token,
        casePreAuthId,
      ].every((field) => field);

      if (data) {
        // call patch url
        if (areFieldsValidPatch && token) {
          const newUrlLink = `${
            PREAUTH_MICROSERVICE.API_MICROSERVICE
          }/template/patch?hospitalId=${hospitalId}&patientId=${patientId}&caseId=${caseId}&casePreAuthId=${casePreAuthId}&schemeId=${schemeId}&schemeName=${schemeName}&isUpdate=${isUpdate}&templateCategory=${templateCategory}&templateSubCategory=${templateSubCategory}&visitId=${visitId}&token=${encodeURIComponent(
            token
          )}`;

          setUrlLink(newUrlLink);
        }
      } else {
        // call post url
        if (areFieldsValidPost && token) {
          const newUrlLink = `${
            PREAUTH_MICROSERVICE.API_MICROSERVICE
          }/template/post?hospitalId=${hospitalId}&patientId=${patientId}&caseId=${caseId}&schemeId=${schemeId}&schemeName=${schemeName}&isUpdate=${isUpdate}&templateCategory=${templateCategory}&templateSubCategory=${templateSubCategory}&visitId=${visitId}&token=${encodeURIComponent(
            token
          )}`;

          // const newUrlLink = `http://localhost:3000/template/post?hospitalId=${hospitalId}&patientId=${patientId}&caseId=${caseId}&schemeId=${schemeId}&schemeName=${schemeName}&isUpdate=${isUpdate}&templateCategory=${templateCategory}&templateSubCategory=${templateSubCategory}&visitId=${visitId}&token=${encodeURIComponent(
          //   token
          // )}`;

          //for preauth documents integration
          // const newUrlLink = `http://localhost:3002/template/post?hospitalId=${hospitalId}&patientId=${patientId}&caseId=${caseId}&schemeId=${schemeId}&schemeName=${schemeName}&isUpdate=${isUpdate}&templateCategory=${templateCategory}&templateSubCategory=${templateSubCategory}&visitId=${visitId}&token=${encodeURIComponent(
          //   token
          // )}`;

          setUrlLink(newUrlLink);
        }
      }
    }
  }, [
    patients?.fetchBasicDetails2?.visitInfoResponse?.id,
    patients?.fetchBasicDetails2?.casesResponse?.patientSchemeId,
    patients?.fetchBasicDetails2?.casesResponse?.id,
    initiateToPreAuth,
  ]);

  useEffect(() => {
    // dispatch(resetPortalData());
    setClaimId(null);
  }, [
    patients?.fetchBasicDetails2?.casesResponse?.id,
    patients?.fetchBasicDetails2?.visitInfoResponse?.id,
  ]);

  useEffect(() => {
    if (discharge?.dischargeID) {
      setDischargeId(discharge?.dischargeID);
    }
  }, [discharge?.dischargeID]);

  useEffect(() => {
    if (patients?.fetchBasicDetails2?.casesResponse?.id || patients?.fetchBasicDetails?.casesResponse?.id) {
      fetchStepper();
    }
  }, [dispatch, patients?.fetchBasicDetails?.casesResponse?.id, patients?.fetchBasicDetails2?.casesResponse?.id]);

  useEffect(() => {
    if (claimId || regId) {
      preAuth?.stepperData?.visitStages?.forEach((stage: any) => {
        if (
          (stage?.visitStage?.toLowerCase() === "preauth" &&
            !stage?.canNavigate &&
            !stage?.completed) ||
          (stage?.visitStage?.toLowerCase() === "registration" &&
            !stage?.canNavigate &&
            !stage?.completed)
        ) {
          fetchStepper();
        }
      });
    }
  }, [dispatch, claimId, regId]);

  const fetchStepper = () => {
    if (patients?.fetchBasicDetails?.casesResponse?.id) {
      const visitId = patients?.fetchBasicDetails?.visitInfoResponse?.id;
      const caseId = patients?.fetchBasicDetails?.casesResponse?.id;
      dispatch(fetchPreAuthStepper({ caseId: caseId, visitId: visitId }));
    }
  };

  const fetchStepperForStatus = () => {
    if (patients?.fetchBasicDetails?.casesResponse?.id) {
      const visitId = patients?.fetchBasicDetails?.visitInfoResponse?.id;
      const caseId = patients?.fetchBasicDetails?.casesResponse?.id;
      dispatch(fetchStepperData({ caseId: caseId, visitId: visitId }));
    }
  };

  useEffect(() => {
    if (visitId) {
      dispatch(getBasicDetails2({ id: parseInt(visitId) }));
      dispatch(
        getBasicDetails({
          id: parseInt(visitId),
        })
      );
    }
  }, [dispatch, visitId]);

  // useEffect(() => {

  //   const patientId = patients?.fetchBasicDetails?.patientResponse?.id
  //   if (patients.patientSchemes === null) {
  //     dispatch(
  //       getPatientSchemes({
  //         id: parseInt(patientId),
  //         accessToken: auth.accessToken || "",
  //       })
  //     );
  //     // dispatch(resetUpdateReferral());
  //   }
  // }, []);
  // useEffect(() => {
  //   const patientId = preAuth?.portalData?.id;

  //   if (patients.selectedPatient === null) {
  //     dispatch(
  //       getPatientById({
  //         id: patientId,
  //         accessToken: auth.accessToken || "",
  //       })
  //     );
  //   }
  // }, [patients?.fetchBasicDetails?.patientResponse?.id]);

  return (
    <>
      {/* <h3 style={{marginTop: 0}}>STATUS: {patients?.fetchBasicDetails?.visitInfoResponse?.message}</h3> */}
      <PreAuthStepper
        prev={prev}
        next={next}
        currentStep={preAuth?.currentStep}
        wizardSteps={preAuth?.allWizardSteps}
        urlLink={urlLink}
        setUrlLink={setUrlLink}
        handleInitiatePreAuth={handleInitiatePreAuth}
        initiateToPreAuth={initiateToPreAuth}
        isCghs={
          patients?.fetchBasicDetails2?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
            "CGHS" ||
          patients?.fetchBasicDetails2?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
            "CAPF"
        }
        visitType={patients?.fetchBasicDetails2?.visitInfoResponse?.visitType?.toUpperCase()}
        schemeName={patients?.fetchBasicDetails2?.casesResponse?.schemeMetaDataName?.toUpperCase()}
        claimId={claimId ? claimId : null}
        setClaimId={setClaimId}
        patientDetails={patients?.fetchBasicDetails2}
        dischargeId={dischargeId}
        isEditing={isEditing}
        statusOptions={statusOptions}
        currentStatus={currentStatus}
        selectedStatusValue={selectedStatusValue}
        handleEditClick={handleEditClick}
        handleChange={handleChange}
        handleSaveClick={handleSaveClick}
        handleCancelClick={handleCancelClick}
        newSteps={preAuth?.stepperData}
        setWizards={setWizards}
        handleCurrentStep={handleCurrentStep}
        fetchStepper={fetchStepper}
        stepperForStatus={fetchStepperForStatus}
        regId={regId}
        setRegId={setRegId}
        // completedStep = {getNextStepForWizard(patients?.fetchBasicDetails?.visitInfoResponse?.message || "PENDING")?.steps}
        // setCallVisit={setCallVisit}
      />
      {/* <FloatingDrawer
        schemeMetaDataId={
          patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId
        }
        schemeMetaDataName={
          patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName
        }
        caseId={patients?.fetchBasicDetails?.casesResponse?.id}
        visitId={patients?.fetchBasicDetails?.visitInfoResponse?.id}
        stepNumber={preAuth?.currentStep}
      /> */}
    </>
  );
};
export default PreAuthContainer;
